function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.096,
    height: 17.986,
    viewBox: "0 0 17.096 17.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Filter Reset"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6198"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6187"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 640",
    d: "M5899.031 2050.89h-5.383l4.634 7.888v4.656l3.254 2.457v-5.543",
    transform: "translate(-5893.148 -2048.405)",
    style: {
      fill: "none",
      stroke: "#14a4c2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6200"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6199"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6195"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 71",
    d: "M5.224 0A5.224 5.224 0 0 0 0 5.224c1.263.038 1 0 1.045 0A4.179 4.179 0 0 1 8.68 2.873H7.313v1.045h3.134V.784H9.4v1.305A5.214 5.214 0 0 0 5.224 0z",
    transform: "matrix(1 -.017 .017 1 6.376 .366)",
    style: {
      fill: "#ffa539"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "History"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 71",
    d: "M5.224 0A5.224 5.224 0 0 0 0 5.224c1.263.038 1 0 1.045 0a4.179 4.179 0 0 1 7.634-2.351H7.313v1.045h3.134V.784H9.4V2.09A5.214 5.214 0 0 0 5.224 0z",
    transform: "matrix(-1 .017 -.017 -1 16.998 10.395)",
    style: {
      fill: "#ffa539"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.67f24ec416a0a3f4c5b4edbfc1ca5b50.svg";
export { ForwardRef as ReactComponent };